import { VendorBuyingAgreementRebateCategoryPermissions } from '../../../components/Vendor';

export function BuyingAgreementRebateCategoryPermissions() {
  return <VendorBuyingAgreementRebateCategoryPermissions />;
}
